export default __webpack_public_path__ + "static/media/ico-chevron-reg-down.0f2d1021.svg";